import { Injectable } from '@angular/core';
import { DateRange, DateRangeContext, DateRangePresetType } from '@services/core-services/models';
import { getDateRange } from '@services/core-services/date-range.utils';

const PRESETS = [
  { value: DateRangePresetType.Today, name: 'Today' },
  { value: DateRangePresetType.Yesterday, name: 'Yesterday' },
  { value: DateRangePresetType.D7, name: '7D' },
  { value: DateRangePresetType.D30, name: '30D' },
  { value: DateRangePresetType.M3, name: '3M' },
  { value: DateRangePresetType.M6, name: '6M' },
  { value: DateRangePresetType.M12, name: '12M' },
  { value: DateRangePresetType.WTD, name: 'WTD' },
  { value: DateRangePresetType.MTD, name: 'MTD' },
  { value: DateRangePresetType.QTD, name: 'QTD' },
  { value: DateRangePresetType.YTD, name: 'YTD' },
  { value: DateRangePresetType.InTheLastXDays, name: 'In the last X days', special: true },
  { value: DateRangePresetType.SinceDate, name: 'Since date' },
  { value: DateRangePresetType.AllTime, name: 'All time' },
  { value: DateRangePresetType.Custom, name: 'Custom' },
];

export interface RangePreset {
  value: string;
  name: string;
  special?: boolean;
}

@Injectable({ providedIn: 'root' })
export class DateRangeService {
  getPresets(): RangePreset[] {
    return PRESETS.map(preset => ({ ...preset }));
  }

  getDateRangeContext(
    preset: DateRangePresetType,
    date = new Date(),
    days?: number,
    r?: DateRange
  ): DateRangeContext {
    return getDateRange(preset, date, days, r);
  }
}
